import React from "react";
import { useParams } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";

export const PaymentPage: React.FC = () => {
    const { id } = useParams<{ id: string }>();

    return (
        <div className="page_content" style={{
            minHeight: "90vh",
            background: "#f9f9fb",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "24px"
        }}>
            <HelmetProvider>
                <Helmet title="Оплата заказа" />
            </HelmetProvider>

            <div style={{
                width: "100%",
                maxWidth: 560,
                background: "#fff",
                borderRadius: 24,
                padding: "32px 28px",
                boxShadow: "0 12px 30px rgba(0,0,0,0.06)",
                textAlign: "center"
            }}>
                <div style={{
                    width: 72,
                    height: 72,
                    borderRadius: "50%",
                    background: "#F2EFFF",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 20px",
                    fontSize: 32
                }}>
                    💳
                </div>

                <h1 style={{
                    fontSize: 26,
                    fontWeight: 600,
                    marginBottom: 12,
                    color: "#1f1f1f"
                }}>
                    Онлайн-оплата
                </h1>

                <p style={{
                    fontSize: 16,
                    lineHeight: "22px",
                    color: "#666",
                    marginBottom: 20
                }}>
                    Здесь появится подключенная онлайн оплата.
                </p>

                {id && (
                    <div style={{
                        background: "#fafafa",
                        borderRadius: 14,
                        padding: "12px 16px",
                        fontSize: 14,
                        color: "#888",
                        marginBottom: 24
                    }}>
                        Номер платежа: <strong>{id}</strong>
                    </div>
                )}

                <div style={{
                    fontSize: 14,
                    color: "#999"
                }}>
                    При подключении сайта здесь пользователь сможет оплатить заказ
                </div>
            </div>
        </div>
    );
};

export default PaymentPage;
